import { ICustomIconProps } from '../_CustomIcon';
import { ReactComponent as IconComponent } from './Icon.svg';
import { StyledAiBotIcon } from './Styles';

const AiBotIcon = (props: ICustomIconProps) => <StyledAiBotIcon icon={IconComponent} {...props} />;

export default AiBotIcon;
